import { ApiClient } from './ApiClient';
import { IClient } from '../interfaces/IUser';

class ClientService {
  private apiClient: ApiClient;

  constructor(apiClient: ApiClient) {
    this.apiClient = apiClient;
  }

  async getAllClients(): Promise<IClient[]> {
    try {
      const data = await this.apiClient.get<IClient[]>('/clients');
      return data || [];
    } catch (error) {
      console.error('Error fetching clients:', error);
      throw error;
    }
  }

  async getClientById(id: string): Promise<IClient> {
    try {
      const data = await this.apiClient.get<IClient>(`/clients/${id}`);
      return data;
    } catch (error) {
      console.error('Error fetching client:', error);
      throw error;
    }
  }

  async createClient(data: Omit<IClient, 'id'>): Promise<IClient> {
    try {
      const created = await this.apiClient.post<IClient>('/clients', data);
      return created;
    } catch (error) {
      console.error('Error creating client:', error);
      throw error;
    }
  }

  async updateClient(id: string, data: Partial<IClient>): Promise<IClient> {
    try {
      const updated = await this.apiClient.put<IClient>(`/clients/${id}`, data);
      return updated;
    } catch (error) {
      console.error('Error updating client:', error);
      throw error;
    }
  }

  async deleteClient(id: string): Promise<void> {
    try {
      await this.apiClient.delete(`/clients/${id}`);
    } catch (error) {
      console.error('Error deleting client:', error);
      throw error;
    }
  }
}

export default ClientService;
